import { Box, Text } from "grommet";
import React from "react";
import { formatCurrency } from "../../utils/numbers";

/*
    The checkout's outer card and its total row, shared by the real checkout and the
    skeleton that stands in for it during server rendering.

    Shared rather than copied because the two have to occupy the same space. The skeleton
    used to render the method menu alone, 121px shorter than the real thing, so hydration
    dropped the sidebar's footer by 133px right as the payer was reading it.
*/
const CheckoutCard = ({showTotal, amount, currency, description, children}) => (
    <Box
        border={{round: 'small', width: 'small'}}
        pad="medium"
        background="foreground"
        elevation="medium"
        round="xsmall"
        margin={{top: 'small'}}
    >
        {showTotal && (
            <Box
                direction="row"
                align="center"
                justify="between"
                border={{side: 'bottom', color: "border-strong"}}
                fill="horizontal"
                margin={{top: 'xsmall', bottom: 'small'}}
                pad={{bottom: 'medium'}}>
                <Box direction="column">
                    <Text weight="bold" size="large">Total</Text>
                    {description && (<Text size="small">{description}</Text>)}
                </Box>
                <Text weight="bold" size="large">{formatCurrency(amount, currency)}</Text>
            </Box>
        )}
        <Box width="large">
            {children}
        </Box>
    </Box>
);

export default CheckoutCard;
